<div
  tabindex="0"
  [attr.data-choice-id]="choice.id"
  [@focusedTrigger]="active"
  [cmFocus]="focused"
  class="cm-choice-selector-choice"
  [ngStyle]="{ 'width.px': choiceWidth, 'height.px': choiceHeight }"
  [ngClass]="{ active: focused }"
  >
  @if (showAvatar && choice.user) {
    <cm-avatar-thumb
      [user]="choice.user"
      [size]="avatarSize"
    ></cm-avatar-thumb>
  }
  @if (showIcon && choice.icon) {
    <mat-icon
      [svgIcon]="choice.icon"
      [ngStyle]="{ 'width.px': iconWidth, 'height.px': iconHeight }"
    ></mat-icon>
  }
  @if (choice.label !== '') {
    <h4
      class="label"
    [style.text-align]="
      showAvatar || showIcon || showToggle ? 'left' : 'center'
    "
      >
      {{ choice.label | uppercase }}
    </h4>
  }
  @if (isCurrentChoice) {
    <div class="current-choice"></div>
  }
  @if (showToggle) {
    <cm-toggle-switch
      [active]="choice.active"
    ></cm-toggle-switch>
  }
</div>
